var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanDefaultAvatarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#444759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 32.9001C32.2534 32.9001 35.7008 29.1393 35.7008 24.5001C35.7008 19.8609 32.2534 16.1001 28.0008 16.1001C23.7482 16.1001 20.3008 19.8609 20.3008 24.5001C20.3008 29.1393 23.7482 32.9001 28.0008 32.9001Z",
    fill: "#707381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9727 50.7633C12.0795 39.9805 17.4025 34.5686 27.9417 34.5276C38.4808 34.4866 43.9716 39.7827 44.414 50.4159C39.4302 54.1388 33.9507 56.0002 27.9757 56.0002C22.0007 56.0002 16.6664 54.2546 11.9727 50.7633Z",
    fill: "#707381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanDefaultAvatarLight);
export default __webpack_public_path__ + "static/media/human-default-avatar-light.fd461621cfd8d408dfdd2eae8c027eca.svg";
export { ForwardRef as ReactComponent };